@if (renderTitle) {
  <h1>{{uiText.PAGE_TITLE | hisUi}}</h1>
}
@defer (when renderSelf) {
  <div>
    <his-confirm-dialog />
    @if (shouldRenderDialogHeader()) {
      <his-dialog-header
        [showBackButton]="false"
        [showResetButton]="false"
        [showSaveButton]="false">
        <ng-container dataBox>
          <strong>{{ getPersonName(ownerId) }}</strong>
        </ng-container>
      </his-dialog-header>
    }
    <div class="clearAndSpace"></div>
    <his-communication-log-filter (filterSettingsChanged)="applyFilterSettings($event)"
      [availableDomains]="allDomains"
      [domainPreselection]="domainRestriction"
      [filters]=" filters"
      [renderOwnerActivityFilter]="this.ownerActivityFilterActive">
    </his-communication-log-filter>
    @if (infoText) {
      <div class="infoMessage" role="note">{{ infoText }}</div>
    }
    @if (canCreateConversationRecord) {
      <button
        type="button"
        (click)="creationDialog.showDialog()"
        hisImage="plus_circ_green" class="transparent">
        {{uiText.CREATE_X | hisUi: (uiText.COMMUNICATION_LOG_CONVERSATIONRECORD | hisUi)}}
      </button>
    }
    <his-communication-log-entries #logEntries
      [logEntries]="filteredLogEntries"
      [ownerId]="ownerId"
      (editEntry)="editEntryById($event)"
      (deleteEntry)="deleteEntryById($event)"
      (requestMoreEntries)="loadMoreEntries()"
      [isDataComplete]="this.allEntriesLoaded"
      [availableDomains]="allDomains"
      appScrollNearEnd="250" (nearEnd)="loadMoreEntries()">
    </his-communication-log-entries>
    <his-conversation-record-edit #creationDialog
      [availableDomains]="allDomains"
      (conversationRecord)="saveConversationRecord($event)">
    </his-conversation-record-edit>
  </div>
}
